/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
// material ui components
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from "@mui/material/Typography";

function LeadNumberedHeading({ number, title, instructions }) {

  return (
    <List className="p-0">
      <ListItem alignItems="flex-start" className="p-0 mt-16">
        <ListItemAvatar className="mr-8 mt-0" sx={{ minWidth: 24}}>
          <Avatar
            sx={{ width: 32, height: 32, color: '#6b7280', borderColor: '#6b7280' }}
            className="text-lg font-semibold m-0 border-1 bg-transparent"
          >
            {number}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          className="m-0"
          primary={
            <Typography className="text-xl font-bold leading-8">
              {title}
            </Typography>
          }
        />
      </ListItem>

      <Divider className="my-16" />

      <Typography variant="body1" className="mb-32">
        {instructions}
      </Typography>
    </List>
  );
}

export default LeadNumberedHeading;
